import React from "react";
import PropTypes from "prop-types";
import { components } from "react-select";
import { wrapperStyle } from "./search_refine_multi_select_checkbox_option.module.scss";

export default function SearchRefineMultiSelectCheckboxOption(props) {
  const { Option } = components;

  return (
    <Option {...props}>
      <div className={wrapperStyle}>
        <input
          type="checkbox"
          id={props.label}
          checked={props.data.isRefined}
        />
        {props.label}
      </div>
    </Option>
  );
}

SearchRefineMultiSelectCheckboxOption.propTypes = {
  data: PropTypes.shape({
    isRefined: PropTypes.bool,
  }),
  label: PropTypes.string,
};
SearchRefineMultiSelectCheckboxOption.defaultProps = {
  data: PropTypes.shape({
    isRefined: false,
  }),
  label: null,
};
